import type { ErrorInfo } from 'react';
import React from 'react';

import * as Sentry from '@sentry/react';

import FallbackWrapper from './fallback-wrapper';

type ErrorBoundaryState = {
  hasError: boolean;
};
type ErrorBoundaryProps = {
  children: React.ReactNode;
  fallback: React.ReactNode;
};

export default class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: unknown): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key as keyof ErrorInfo]);
      });
      Sentry.captureException(error);
    });
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return <FallbackWrapper>{this.props.fallback}</FallbackWrapper>;
    }
    return this.props.children;
  }
}
